import ChevronIcon from '@/fo/icons/base/icons/chevron.svg';
import { MenuItem } from '@/fo/ui/app/menu/base';

import { Items } from '../Items/Items';

import { styles } from './NestedScreen.styles';

export interface NavigationLevel {
  items: MenuItem[];
  index: number;
  title: string;
}

export interface NestedScreenProps {
  navigationHistory: NavigationLevel[];
  onBackClick: () => void;
  onMenuItemClick: (items: MenuItem[], index: number, title: string) => void;
}

export function NestedScreen({
  navigationHistory,
  onBackClick,
  onMenuItemClick
}: NestedScreenProps) {
  const slots = styles();
  if (navigationHistory.length === 0) return null;

  const currentLevel = navigationHistory[navigationHistory.length - 1];
  const selectedItem = currentLevel.items[currentLevel.index];

  if (!selectedItem || !selectedItem.children) return null;

  const mappedChildren = selectedItem.children.slice();

  return (
    <div className={slots.base()}>
      <button
        className={slots.backButton()}
        onClick={onBackClick}
      >
        <ChevronIcon className={slots.backIcon()} />
        <span>{currentLevel.title}</span>
      </button>

      <Items
        items={mappedChildren}
        props={(item, index) => ({
          onClick: () =>
            onMenuItemClick(mappedChildren || [], index, item.label)
        })}
      />
    </div>
  );
}
